import React from 'react';
import { Formik } from 'formik';
import { deliveredQuantityValidationSchema } from 'pages/Orders/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import EditDeliveredQuantityForm from './components/EditDeliveredQuantityForm';

const EditDeliveredQuantity = ({
  drawerToggle,
  onDeliveredStatusConfirmation,
  deliveredQuantity,
}) => {
  const handleSubmit = (values) => {
    onDeliveredStatusConfirmation(values?.deliveredQuantity);
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          enableReinitialize
          validationSchema={deliveredQuantityValidationSchema}
          initialValues={{
            deliveredQuantity: deliveredQuantity || '',
          }}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <EditDeliveredQuantityForm
                {...props}
                drawerToggle={drawerToggle}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default EditDeliveredQuantity;
